import { theme } from './theme.js'

export default theme
